import * as React from 'react';

export type RadioContentProps = {
  children?: React.ReactNode;
};

/**
 * Renders the container for `<RadioLabel />` and `<RadioContent />` within a `<Radio />` component.
 */
export const RadioContent = React.forwardRef<any, RadioContentProps>(
  (props, forwardedRef) => <div {...props} ref={forwardedRef} />
);

RadioContent.displayName = 'RadioContent';
